// For Testing Purposes
export const initialStages = [
	{
		id: 1,
		provider: "jili",
		gameName: "Feng Shen",
		x: "20.2%",
		y: "61.8%",
		xM: "52%",
		yM: "85.4%",
		logo: "/images/jili-quest/FENG_SHEN.webp",
		requiredTurnover: 5000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 5,
				label: "5 Free Spins",
			},
		],
	},
	{
		id: 2,
		provider: "jili",
		gameName: "3 Coin Wild Tiger",
		x: "51%",
		y: "57.5%",
		xM: "40.4%",
		yM: "65%",
		logo: "/images/jili-quest/3_COIN_WILD_TIGER.webp",
		requiredTurnover: 5000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 10,
				label: "10 Free Credits",
			},
		],
	},
	{
		id: 3,
		provider: "jili",
		gameName: "Mega Ace",
		x: "60.1%",
		y: "39.5%",
		xM: "63.8%",
		yM: "35.4%",
		logo: "/images/jili-quest/MEGA_ACE.webp",
		requiredTurnover: 10000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 10,
				label: "10 Free Spins",
			},
		],
	},
	{
		id: 4,
		provider: "jili",
		gameName: "3 Charge Buffalo",
		x: "47.3%",
		y: "23.4%",
		xM: "39.9%",
		yM: "21.5%",
		logo: "/images/jili-quest/3_CHARGE_BUFFALO.webp",
		requiredTurnover: 10000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 20,
				label: "20 Free Credits",
			},
		],
	},
	{
		id: 5,
		provider: "jili",
		gameName: "Fortune Coins",
		x: "63.6%",
		y: "12.3%",
		xM: "57.1%",
		yM: "12.9%",
		logo: "/images/jili-quest/FORTUNE_COINS.webp",
		requiredTurnover: 25000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 50,
				label: "50 Free Credits",
			},
		],
	},
	{
		id: 6,
		provider: "jili",
		gameName: "Crazy777",
		x: "20.2%",
		y: "61.8%",
		xM: "52%",
		yM: "85.4%",
		logo: "/images/jili-quest/CRAZY_777.webp",
		requiredTurnover: 5000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 10,
				label: "10 Free Credits",
			},
		],
	},
	{
		id: 7,
		provider: "jili",
		gameName: "Fortune Gems 500",
		x: "51%",
		y: "57.5%",
		xM: "40.4%",
		yM: "65%",
		logo: "/images/jili-quest/FORTUNE_GEMS_500.webp",
		requiredTurnover: 10000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 20,
				label: "20 Free Credits",
			},
		],
	},
	{
		id: 8,
		provider: "jili",
		gameName: "Circus Joker 4069",
		x: "60.1%",
		y: "39.5%",
		xM: "63.8%",
		yM: "35.4%",
		logo: "/images/jili-quest/CIRCUS_JOKER.webp",
		requiredTurnover: 10000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 10,
				label: "10 Free Spins",
			},
		],
	},
	{
		id: 9,
		provider: "jili",
		gameName: "Super Ace 2",
		x: "47.3%",
		y: "23.4%",
		xM: "39.9%",
		yM: "21.5%",
		logo: "/images/jili-quest/SUPER_ACE_II.webp",
		requiredTurnover: 15000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 15,
				label: "15 Free Spins",
			},
		],
	},
	{
		id: 10,
		provider: "jili",
		gameName: "Boxing King",
		x: "63.6%",
		y: "12.3%",
		xM: "57.1%",
		yM: "12.9%",
		logo: "/images/jili-quest/BOXING_KING.webp",
		requiredTurnover: 25000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 50,
				label: "50 Free Credits",
			},
		],
	},
	{
		id: 11,
		provider: "jili",
		gameName: "Money Coming",
		x: "20.2%",
		y: "61.8%",
		xM: "52%",
		yM: "85.4%",
		logo: "/images/jili-quest/MONEY_COMING-GAME-LOGO.webp",
		requiredTurnover: 40000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 80,
				label: "80 Free Credits",
			},
		],
	},
	{
		id: 12,
		provider: "jili",
		gameName: "Bubble Beauty",
		x: "51%",
		y: "57.5%",
		xM: "40.4%",
		yM: "65%",
		logo: "/images/jili-quest/BUBBLE_BEAUTY.webp",
		requiredTurnover: 40000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 5,
				label: "5 Free Spins",
			},
			{
				type: "FREE_CREDITS",
				amount: 50,
				label: "50 Free Credits",
			},
		],
	},
	{
		id: 13,
		provider: "jili",
		gameName: "Chin Shi Huang",
		x: "60.1%",
		y: "39.5%",
		xM: "63.8%",
		yM: "35.4%",
		logo: "/images/jili-quest/CHIN_SHI_HUANG.webp",
		requiredTurnover: 40000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 10,
				label: "10 Free Spins",
			},
			{
				type: "FREE_CREDITS",
				amount: 30,
				label: "30 Free Credits",
			},
		],
	},
	{
		id: 14,
		provider: "jili",
		gameName: "Super Ace Deluxe",
		x: "47.3%",
		y: "23.4%",
		xM: "39.9%",
		yM: "21.5%",
		logo: "/images/jili-quest/SUPER_ACE_DELUXE.webp",
		requiredTurnover: 50000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 100,
				label: "100 Free Credits",
			},
		],
	},
	{
		id: 15,
		provider: "jili",
		gameName: "Fortune Gems 2",
		x: "63.6%",
		y: "12.3%",
		xM: "57.1%",
		yM: "12.9%",
		logo: "/images/jili-quest/FORTUNE_GEMS_2.webp",
		requiredTurnover: 50000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 100,
				label: "100 Free Credits",
			},
		],
	},
	{
		id: 16,
		provider: "jili",
		gameName: "Money Coming Expanded Bet",
		x: "20.2%",
		y: "61.8%",
		xM: "52%",
		yM: "85.4%",
		logo: "/images/jili-quest/MONEY-COMING_EXPANDED-BETS.webp",
		requiredTurnover: 50000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 10,
				label: "10 Free Spins",
			},
			{
				type: "FREE_CREDITS",
				amount: 50,
				label: "50 Free Credits",
			},
		],
	},
	{
		id: 17,
		provider: "jili",
		gameName: "Fortune Garuda 500",
		x: "51%",
		y: "57.5%",
		xM: "40.4%",
		yM: "65%",
		logo: "/images/jili-quest/FORTUNE_OF_GARUDA-LOGO.webp",
		requiredTurnover: 50000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 100,
				label: "100 Free Credits",
			},
		],
	},
	{
		id: 18,
		provider: "jili",
		gameName: "Charge Buffalo Ascent",
		x: "60.1%",
		y: "39.5%",
		xM: "63.8%",
		yM: "35.4%",
		logo: "/images/jili-quest/CHARGE_BUFFALO_ASCENT.webp",
		requiredTurnover: 75000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 150,
				label: "150 Free Credits",
			},
		],
	},
	{
		id: 19,
		provider: "jili",
		gameName: "Fortune Gems 3",
		x: "47.3%",
		y: "23.4%",
		xM: "39.9%",
		yM: "21.5%",
		logo: "/images/jili-quest/FORTUNE_GEMS_3-LOGO.webp",
		requiredTurnover: 75000,
		rewards: [
			{
				type: "FREE_SPINS",
				amount: 15,
				label: "15 Free Spins",
			},
			{
				type: "FREE_CREDITS",
				amount: 80,
				label: "80 Free Credits",
			},
		],
	},
	{
		id: 20,
		provider: "jili",
		gameName: "Super Ace",
		x: "63.6%",
		y: "12.3%",
		xM: "57.1%",
		yM: "12.9%",
		logo: "/images/jili-quest/SUPER_ACE-LOGO.webp",
		requiredTurnover: 100000,
		rewards: [
			{
				type: "FREE_CREDITS",
				amount: 200,
				label: "200 Free Credits",
			},
		],
	},
];

export const TEST_TURNOVER_OVERRIDES = {
	week1a: 2000,
};
